import React from "react"


const InputCustom = ({
    label,
    placeholder,
    value,
    onChange,
    icon,
    type = "text",
    required = false,
    className = "",
    disabled = false
}) => {
    return (
        <div className={className} >
            <label className="block mb-2 text-sm font-medium text-neutral-800 dark:text-neutral-200">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </label>
            <div className="relative">
                <input
                    type={type}
                    className={` ${disabled ? 'cursor-not-allowed' : ''} w-full h-10 text-neutral-800 dark:text-neutral-200 pl-10 pr-3 font-[300] text-sm dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-800 rounded-xl focus:outline-none focus:ring-1 focus:ring-yellow-500 dark:focus:ring-yellow-600 focus:border-transparent`}
                    placeholder={placeholder}
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    required={required}
                    disabled={disabled}
                />
                {icon && (
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        {icon}
                    </div>
                )}
            </div>
        </div>
    )
}

export default InputCustom
